(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["elshrouk-3d-modal"] && !Shopify.designMode) return;
  try {
    const modal = document.getElementById('Es3DModal');

  if (modal && modal.dataset.ready !== 'true') {
    modal.dataset.ready = 'true';

    const closeButton = modal.querySelector('[data-es-3d-close]');
    const title = modal.querySelector('[data-es-3d-title]');
    const status = modal.querySelector('[data-es-3d-status]');
    const viewer = modal.querySelector('[data-es-3d-viewer]');
    let previousTrigger = null;

    const showError = () => {
      status.textContent = status.dataset.errorText;
      status.hidden = false;
    };

    const closeModal = () => {
      if (modal.open) modal.close();
    };

    const openModal = (trigger) => {
      const card = trigger.closest('product-card');
      const template = card?.querySelector('.es-card__3d-template');

      if (!(template instanceof HTMLTemplateElement)) return;

      previousTrigger = trigger;
      title.textContent = trigger.dataset.productTitle || trigger.textContent.trim();
      status.textContent = status.dataset.loadingText;
      status.hidden = false;
      viewer.replaceChildren(template.content.cloneNode(true));

      const modelViewer = viewer.querySelector('model-viewer');
      if (!modelViewer) {
        showError();
        return;
      }

      modelViewer.setAttribute('auto-rotate', '');
      modelViewer.setAttribute('rotation-per-second', '18deg');
      modelViewer.style.position = 'absolute';
      modelViewer.style.inset = '0';
      modelViewer.style.width = '100%';
      modelViewer.style.height = '100%';
      modelViewer.addEventListener('load', () => {
        status.hidden = true;
      }, { once: true });
      modelViewer.addEventListener('error', showError, { once: true });

      if (!modal.open) modal.showModal();

      if (window.Shopify && typeof window.Shopify.loadFeatures === 'function') {
        window.Shopify.loadFeatures([
          {
            name: 'model-viewer-ui',
            version: '1.0',
            onLoad: (errors) => {
              if (errors || !viewer.contains(modelViewer)) {
                if (errors) showError();
              }
            },
          },
        ]);
      } else {
        showError();
      }
    };

    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element)) return;

      const trigger = event.target.closest('[data-es-3d-trigger]');
      if (!trigger) return;

      event.preventDefault();
      event.stopPropagation();
      openModal(trigger);
    }, true);

    closeButton.addEventListener('click', closeModal);
    modal.addEventListener('click', (event) => {
      if (event.target === modal) closeModal();
    });
    modal.addEventListener('close', () => {
      viewer.replaceChildren();
      status.textContent = status.dataset.loadingText;
      status.hidden = false;
      previousTrigger?.focus();
      previousTrigger = null;
    });
  }
  } catch(e) { console.error(e); }
})();

})();
